// extracted by mini-css-extract-plugin
export default {"log-reg":"Account_log-reg__syyjN","log":"Account_log__cqzmc","reg":"Account_reg__QBJZ9"};